<div class="bmc-working-time-schema-viewer" (mouseleave)="onLeave()">
    <bs-datepicker-inline *ngIf="showCalendar" (mouseout)="onLeave()" (mouseover)="onOver($event)" [bsConfig]="bsConfig" [dateCustomClasses]="dateCustomClasses" (bsValueChange)="setSelectedDay($event)"></bs-datepicker-inline>
</div>
<div id="working-day-detail" *ngIf="showDetail">
  <time-details  [showClose]="false" [isCustom]="calendarDic[selectedDateDetail]" [editedHours]="editedHours"  [customWorkingHour]="calendarDic[selectedDateDetail] || weekDaysSchedule[selectedDateDetail]" ></time-details>
</div>
